import React, { Component } from 'react';
import PrintQRView from '../views/PrintQRView';
import { base } from '../../base';

class PrintQRContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            company: [],
            machines: [],
        };
    }

    componentDidMount() {
        const { params } = this.props.match;
        const ctx = this;
        this.refData = base.syncState(`machines/${params.companyid}`, {
            context: this,
            state: 'machines',
            asArray: true,
        });

        base.fetch(`companies/${params.companyid}`, {
            context: ctx,
            then(data) {
                ctx.setState({ company: data });
            },
        });
    }

    componentWillUnmount() {
        base.removeBinding(this.refData);
    }

    render() {
        const { params } = this.props.match;
        return (
            <PrintQRView
                companyid={params.companyid}
                company={this.state.company}
                machines={this.state.machines}
            />
        );
    }
}

export default PrintQRContainer;



// WEBPACK FOOTER //
// ./src/components/containers/PrintQRContainer.js